import React from 'react';
import { ReportSection } from './ReportSection';
import { sharesOf } from '../../utils/reportFormat';
import type { MonthlyClubReport } from '../../types/monthlyClubReport';
const CHANNEL_COLOURS = ['#0EA5E9', '#10B981', '#6F42C1'];
export function SignupsSection({
  report
}: {
  report: MonthlyClubReport;
}) {
  const channels = report.signupChannels;
  const shares = sharesOf(channels.map(c => c.thisMonth));
  const total = (key: 'thisMonth' | 'prev' | 'yearAgo') => channels.reduce((sum, c) => sum + c[key], 0);
  return <ReportSection id="signups" title="Sign-ups" data-id="element-3696" data-mp="3sczzbspnayl3">
      <div className="flex items-baseline gap-2 mb-4" data-id="element-3697" data-mp="3nkqakg09o4ke">
        <span className="text-[28px] font-semibold text-[#0F172A] leading-none" data-id="element-3698" data-mp="3njf7kienb0uc">
          {total('thisMonth')}
        </span>
        <span className="text-sm text-[#64748B]" data-id="element-3699" data-mp="3ik2jjuc1fnq6">total new sign-ups</span>
      </div>

      <div className="flex h-3 rounded-full overflow-hidden bg-[#F1F5F9] mb-2" role="img" aria-label={channels.map((c, i) => `${c.label} ${shares[i]}%`).join(', ')} data-id="element-3700" data-mp="jxzp6dqd2aln">
        {channels.map((c, i) => <div key={c.label} style={{
        width: `${shares[i]}%`,
        backgroundColor: CHANNEL_COLOURS[i % CHANNEL_COLOURS.length]
      }} data-id="element-3701" data-mp="2z2l811nih8s1" data-mpi={i} />)}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mb-5" data-id="element-3702" data-mp="2qaaxfj8pf1a9">
        {channels.map((c, i) => <span key={c.label} className="flex items-center gap-1.5 text-xs text-[#475569]" data-id="element-3703" data-mp="2ual28skrflnj" data-mpi={i}>
            <span className="w-2.5 h-2.5 rounded-full" style={{
          backgroundColor: CHANNEL_COLOURS[i % CHANNEL_COLOURS.length]
        }} data-id="element-3704" data-mp="2gbldlkx8z6rd" />
            {c.label} {shares[i]}%
          </span>)}
      </div>

      <div className="overflow-x-auto" data-id="element-3705" data-mp="27b5gct73kvuy">
        <table className="w-full text-sm" data-id="element-3706" data-mp="27cggmj1c3lhb">
          <thead data-id="element-3707" data-mp="2bbyzzadiboi1">
            <tr className="border-b border-[#E2E8F0] text-[12px] font-semibold text-[#94A3B8] uppercase tracking-[0.5px]" data-id="element-3708" data-mp="2bbgxvx45yg27">
              <th scope="col" className="text-left py-2 pr-4" data-id="element-3709" data-mp="5js9vzphefws">Where they signed up</th>
              <th scope="col" className="text-right py-2 px-4" data-id="element-3710" data-mp="9juae5jhd3ah">This month</th>
              <th scope="col" className="text-right py-2 px-4" data-id="element-3711" data-mp="1iic1sv35bhsy">{report.prevColumn}</th>
              <th scope="col" className="text-right py-2 px-4" data-id="element-3712" data-mp="1dizc82kw3wmo">{report.yearAgoShort}</th>
              <th scope="col" className="text-right py-2 pl-4" data-id="element-3713" data-mp="19h4flbdwm7f8">Share this month</th>
            </tr>
          </thead>
          <tbody data-id="element-3714" data-mp="14ikqj240kfin">
            {channels.map((c, i) => <tr key={c.label} className="border-b border-[#E2E8F0]" data-id="element-3715" data-mp="14jm3xd8i5e3j" data-mpi={i}>
                <td className="py-3 pr-4 text-[#0F172A]" data-id="element-3716" data-mp="2178uwvmt449l">
                  <span className="flex items-center gap-2" data-id="element-3717" data-mp="1x6oyjua254oi">
                    <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{
                  backgroundColor: CHANNEL_COLOURS[i % CHANNEL_COLOURS.length]
                }} data-id="element-3718" data-mp="1x78ithn6k55p" />
                    {c.label}
                  </span>
                </td>
                <td className="py-3 px-4 text-right font-medium text-[#0F172A]" data-id="element-3719" data-mp="2kwt3c4yzfah3">{c.thisMonth}</td>
                <td className="py-3 px-4 text-right text-[#475569]" data-id="element-3720" data-mp="2g51a1mofyqn9">{c.prev}</td>
                <td className="py-3 px-4 text-right text-[#475569]" data-id="element-3721" data-mp="2ngpfcjizqjpb">{c.yearAgo}</td>
                <td className="py-3 pl-4 text-right text-[#475569]" data-id="element-3722" data-mp="2nj253iuzpycx">{shares[i]}%</td>
              </tr>)}
            <tr className="font-semibold text-[#0F172A]" data-id="element-3723" data-mp="2shn4xh6byg0u">
              <td className="py-3 pr-4" data-id="element-3724" data-mp="2xe3vei1056h3">Total</td>
              <td className="py-3 px-4 text-right" data-id="element-3725" data-mp="31gidv10re47u">{total('thisMonth')}</td>
              <td className="py-3 px-4 text-right" data-id="element-3726" data-mp="31edxvkpl5er7">{total('prev')}</td>
              <td className="py-3 px-4 text-right" data-id="element-3727" data-mp="36esa7ey7zav1">{total('yearAgo')}</td>
              <td className="py-3 pl-4 text-right" data-id="element-3728" data-mp="3be4x1zp3chxm">100%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ReportSection>;
}